import { currentWeek, currentWeekYear } from './currentWeek';

/**
 * Constructs a weekKey in the format "weekNumber-year".
 * @param date - The date within the week.
 * @returns The weekKey string.
 */
export const constructWeekKey = (date: Date): string => {
  const weekNum = currentWeek(date);
  const weekYear = currentWeekYear(date);
  return `${weekNum}-${weekYear}`;
};

/**
 * Returns the canonical ISO key plus the historical calendar-year variant.
 * Both values differ only for ISO weeks that cross a calendar-year boundary.
 */
export const constructCompatibleWeekKeys = (date: Date): string[] => {
  const weekNum = currentWeek(date);
  const weekStart = new Date(date);
  const day = weekStart.getDay();
  weekStart.setDate(weekStart.getDate() + (day === 0 ? -6 : 1 - day));
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);

  return [
    ...new Set([
      constructWeekKey(date),
      `${weekNum}-${weekStart.getFullYear()}`,
      `${weekNum}-${weekEnd.getFullYear()}`,
    ]),
  ];
};

export const isWeekApproved = (
  date: Date,
  approvedWeeks: string[] = []
): boolean =>
  constructCompatibleWeekKeys(date).some((weekKey) =>
    approvedWeeks.includes(weekKey)
  );
